import React, {useEffect, useState} from 'react'
import AddCommunityLeadPersonal from './AddCommunityLeadPersonal';
import AddLeadBusiness from './AddLeadBusiness'
import AddLeadDirector from './AddLeadDirector'
import AddLeadAddress from './AddLeadAddress';
import AddLeadDocument from './AddLeadDocument';
import AddLeadLoan from './AddLeadLoan'
import AddSalariedDetails from './AddSalariedDetails'
import AddLeadProperty from './AddLeadProperty'
export default function Main({Pagedata, handlePage}) {
    const [tab,setTab] =useState("personal")
    const [data,setData] =useState("")
    useEffect(()=>{
console.log("tab",tab)
    },[tab])
    const handleTab=(type,data)=>{
      setData(data)
      setTab(type)
    }
  return (
    <div>
        {
            tab === "personal"?
            <AddCommunityLeadPersonal Pagedata={Pagedata} handlePage={handlePage} handleTab={handleTab}/>
        :''}
        {
            tab === "adminAddLeadBusiness"?
            <AddLeadBusiness  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}
        {
            tab === "addLeadDirector"?
            <AddLeadDirector  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}
        {
            tab === "addLeadAddress"?
            <AddLeadAddress  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}
        {
            tab === "addLeadLoan"?
            <AddLeadLoan  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}
        {
            tab === "addLeadDocument"?
            <AddLeadDocument  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}

        {
            tab === "addLeadSalariedDetails"?
            <AddSalariedDetails  handlePage={handlePage} handleTab={handleTab} Locationdata={data}/>
        :''}

        {
            tab === "addLeadProperty"?
            <AddLeadProperty  handlePage={handlePage} handleTab={handleTab} data={data}/>
        :''}
    </div>
  )
}
